import React, { useEffect, useState } from "react";
import moment from "moment";
import { Card, Table, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { fetchPastUploads } from "../../Store/pastUploadsSlice";

const { Search } = Input;

function ViewPastUploads() {
  const dispatch = useDispatch();

  const {
    pastUploads,
    pagination,
    loading,
  } = useSelector((state) => state.pastUploads);

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(
      fetchPastUploads({
        pageNumber,
        pageSize,
        search,
      })
    );
  }, [dispatch, pageNumber, pageSize, search]);

  const columns = [
    {
      title: "Audit Universe",
      dataIndex: "AUDITUNIVERSE",
      key: "AUDITUNIVERSE",
    },

    {
      title: "Process Name",
      dataIndex: "PROCESSNAME",
      key: "PROCESSNAME",
    },

    {
      title: "Sub Process Name",
      dataIndex: "SUBPROCESSNAME",
      key: "SUBPROCESSNAME",
    },

        {
      title: "Email",
      dataIndex: "EMAIL",
      key: "EMAIL",
    },
    

    {
      title: "Uploaded On",
      dataIndex: "CREATED_ON",
      key: "CREATED_ON",

      render: (date) =>
        date
          ? moment(date).format(
              "DD/MM/YYYY HH:mm:ss"
            )
          : "-",
    },
  ];

  return (
    <Card className="h-full">
      <div className="flex justify-between items-center mb-4">
        <div className="text-2xl font-semibold">
          Past Uploads
        </div>

        <Search
          placeholder="Search..."
          allowClear
          onSearch={(value) => {
            setSearch(value);
            setPageNumber(1);
          }}
          style={{ width: 300 }}
        />
      </div>

      <Table
        dataSource={pastUploads}
        loading={loading}
        columns={columns}
        rowKey={(record, index) => index}
        bordered
        scroll={{ x: 1000 }}

        pagination={{
          current: pagination?.CURRENTPAGE || 1,

          total: pagination?.TOTALCOUNT || 0,

          pageSize: pagination?.PAGESIZE || 10,

          showSizeChanger: true,

          onChange: (page, size) => {
            setPageNumber(page);
            setPageSize(size);
          },
        }}
      />
    </Card>
  );
}

export default ViewPastUploads;